import {useEffect, useRef, useState} from "react";

import {useReportOptions} from "@hooks/Report";
import stars from "@images/menu/stars.png";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {ReportPopup} from "@popups/requestPopups/ReportPopup";
import {ControlButton} from "@ui/buttons/ControlButton";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {RootIcon} from "@ui/icons/RootIcon";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Link, useLocation, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const SideBar = (props) => {
  const {list} = props;

  const location = useLocation();
  const navigate = useNavigate();
  const {t} = useTranslation();

  const {openPopup} = usePopup();
  const {isMobile, language} = useSelector((state) => state.common.settings);
  const {role} = useSelector((state) => state.common.candidate);
  const {SIMULATIONS_REPORT_OPTIONS} = useReportOptions();

  const [isOpen, setIsOpen] = useState(false);
  const [activeNav, setActiveNav] = useState({});
  const dropdownRef = useRef(null);

  const companionUrl = document.body.getAttribute("data-ava-ava-companion-url");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleClickLink = (item) => {
    setActiveNav(item);
    setIsOpen(false);
  };

  const handleOpenPopup = () => {
    openPopup(<ReportPopup options={SIMULATIONS_REPORT_OPTIONS} />);
  };

  useEffect(() => {
    list.map((item) => {
      if (location.pathname.includes(item.link)) {
        setActiveNav(item);
      }

      if (location.pathname.includes("profile")) {
        setActiveNav(list[0]);
      }
    });
  }, [location]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const showFakeLink =
    window.location.href.includes("sanofi-demo") ||
    window.location.href.includes("akrikhin-demo") ||
    window.location.href.includes("servier-demo") ||
    window.location.href.includes("valenta-demo");

  return (
    <div className={styles.sidebarWrapper}>
      <RootButton
        onClick={() => navigate("/simulations")}
        txt={
          role !== "Representative"
            ? t("button.simulation_admin")
            : t("button.simulation_rep")
        }
      />

      {!isMobile ? (
        <>
          <BorderArticle>
            <ul className={styles.sidebar}>
              {list &&
                list.map((item) => (
                  <li
                    className={
                      location.pathname.includes(item?.link.split("/")[0])
                        ? `${styles.link} ${styles.activeLink}`
                        : styles.link
                    }
                    key={item?.id}
                  >
                    <Link
                      to={item?.link}
                      state={item?.state}
                    >
                      <RootIcon id={item?.iconId} />

                      <RootDesc>
                        <span>{item?.name}</span>
                      </RootDesc>
                    </Link>
                  </li>
                ))}

              {showFakeLink && (
                <li className={styles.sidebarBtnLink}>
                  <a
                    style={{
                      pointerEvents: "none",
                    }}
                    href={"#"}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                  >
                    <RootIcon
                      id={
                        language === "en"
                          ? "logo-companion-en"
                          : "logo-companion-ru"
                      }
                    />

                    <RootDesc>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("sidebar.companion"),
                        }}
                      />
                    </RootDesc>

                    <img
                      src={stars}
                      alt={"stars"}
                    />
                  </a>
                </li>
              )}

              {companionUrl && (
                <li className={styles.sidebarBtnLink}>
                  <a
                    href={companionUrl}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                  >
                    <RootIcon
                      id={
                        language === "en"
                          ? "logo-companion-en"
                          : "logo-companion-ru"
                      }
                    />

                    <RootDesc>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("sidebar.companion"),
                        }}
                      />
                    </RootDesc>

                    <img
                      src={stars}
                      alt={"stars"}
                    />
                  </a>
                </li>
              )}
            </ul>
          </BorderArticle>

          <div className={styles.sidebar_btn}>
            <ControlButton
              color={"var(--black)"}
              txt={t("button.report")}
              iconId={"report"}
              onClick={handleOpenPopup}
            />
          </div>
        </>
      ) : (
        <div
          className={styles.dropdown}
          ref={dropdownRef}
        >
          <BorderArticle>
            <div className={"w-[100%]"}>
              <div
                className={styles.dropdownHeader}
                onClick={toggleDropdown}
              >
                <div className={styles.link}>
                  <RootIcon
                    width={32}
                    height={32}
                    id={activeNav?.iconId}
                  />

                  <RootDesc>
                    <span>{activeNav?.name}</span>
                  </RootDesc>
                </div>

                <i
                  style={
                    isOpen
                      ? {transform: "rotate(180deg)"}
                      : {transform: "rotate(0deg)"}
                  }
                />
              </div>

              {isOpen && (
                <div className={styles.dropdownList}>
                  <ul>
                    {list &&
                      list
                        .filter((item) => item?.id !== activeNav?.id)
                        .map((item) => (
                          <li
                            key={item?.id}
                            className={
                              location.pathname.includes(
                                item?.link.split("/")[0],
                              )
                                ? `${styles.link} ${styles.activeLink}`
                                : styles.link
                            }
                          >
                            <Link
                              onClick={handleClickLink}
                              to={item?.link}
                              state={item?.state}
                            >
                              <RootIcon
                                width={32}
                                height={32}
                                id={item?.iconId}
                              />

                              <RootDesc>
                                <span>{item?.name}</span>
                              </RootDesc>
                            </Link>
                          </li>
                        ))}

                    {showFakeLink && (
                      <li className={styles.sidebarBtnLink}>
                        <a
                          style={{
                            pointerEvents: "none",
                          }}
                          href={"#"}
                          target={"_blank"}
                          rel={"noopener noreferrer"}
                        >
                          <RootIcon
                            id={
                              language === "en"
                                ? "logo-companion-en"
                                : "logo-companion-ru"
                            }
                          />

                          <RootDesc>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t("sidebar.companion"),
                              }}
                            />
                          </RootDesc>

                          <img
                            src={stars}
                            alt={"stars"}
                          />
                        </a>
                      </li>
                    )}

                    {companionUrl && (
                      <li className={styles.sidebarBtnLink}>
                        <a
                          href={companionUrl}
                          target={"_blank"}
                          rel={"noopener noreferrer"}
                        >
                          <RootIcon
                            id={
                              language === "en"
                                ? "logo-companion-en"
                                : "logo-companion-ru"
                            }
                          />

                          <RootDesc>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t("sidebar.companion"),
                              }}
                            />
                          </RootDesc>

                          <img
                            src={stars}
                            alt={"stars"}
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </BorderArticle>
        </div>
      )}
    </div>
  );
};
